<template>
    <v-ons-page>
        <v-ons-row>
            <v-ons-col>
                <div v-if="initialized" :key="page.timestamp">

                    <div class="content">
                        <img v-if="_.get(pageData.attributes.image)"
                            :src="imgPath(pageData.attributes.image)"
                            :alt="_.get(pageData, 'attributes.image.name')">
                        <div v-html="_.get(pageData, 'attributes.content')"></div>
                    </div>
                </div>
                <div v-else class="text-center page-progress-loader">
                    <v-ons-progress-circular
                        indeterminate
                        ></v-ons-progress-circular>
                </div>
            </v-ons-col>
        </v-ons-row>

    </v-ons-page>
</template>

<script>
import Utils from './mixins/Utils'
import Module from './mixins/Module'
import ProgressBar from './partials/ProgressBar'

export default {
    data () {
        return {
            initialized: false,
            processing: false,
        }
    },

    created() {
        if (!this.customer.content.id) {
            return this.$router.push({ name: 'login' })
        }

        let pageId = this.$route.params.id;
        this.page.getInitialData(`/pages/${pageId}`, {
            token: this.getToken(),
        }).then((res) => {
            this.$emit('init', {
                name: 'page',
                title: _.get(res, 'attributes.title'),
                showMenu: true,
            })
            this.initialized = true;
        })
    },

    mixins: [
        Utils,
        Module('customer'),
        Module('page'),
    ],

    components: {
        ProgressBar,
    },

    computed: {
        pageData() {
            return _.get(this.page, 'content') || {}
        },

        customerData() {
            return _.get(this.customer, 'content.attributes') || {}
        },
    },

    methods: {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
    background: white;
    padding: 1rem;
    color: #000;
}

img {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ContentPage.vue